import "material-design-icons-iconfont/dist/material-design-icons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import { Ripple } from "vuetify/lib/directives";

//import "@fontawesome/fontawesome-free/css/all.css";

Vue.use(Vuetify, {
    directives: {
        Ripple
    }
});

const opts = {
    defaultAssets: {
        font: true,
        icons: "fa"
    },
    icons: {
        iconfont: "fa"
    },
    theme: {
        themes: {
            light: {
                primary: "#F41823",
                "bal-gray": "#F0F0F0",
                "bal-dark-gray": "#888",
                "bal-red": "#F41823",
                "bal-green": "#4CAF50",
                "bal-orange": "#FB8C00"
            }
        }
    }
};

export default new Vuetify(opts);
